// @ts-nocheck
/* global css */
import React, {
  ChangeEvent, useState, useEffect,
} from 'react';
import { cssInJS } from '../../utils/styles';
import THEME from '../../shared/theme';

interface Props {
  disabled: boolean;
  value: { textValue: string };
  min: number;
  max: number;
  onChange(newVal: { textValue: string }): void;
  onFocusChange(hasFocus: boolean): void;
}

/**
 * @deprecated this file has been replaced by number-field.tsx
 */
const NumberField: React.FC<Props> = ({
  disabled,
  value,
  min,
  max,
  onChange,
  onFocusChange,
}: Props) => {
  const [textValue, setTextValue] = useState<string>(value.textValue || '');

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const inputValue = event.target.value;

    setTextValue(inputValue);
    value.textValue = inputValue;
    onChange(value);
  };

  useEffect(() => {
    setTextValue(value.textValue || '');
  }, [value]);

  return (
    <input
      type="number"
      step="any"
      className={css(styles.default)}
      disabled={disabled}
      min={min}
      max={max}
      value={textValue}
      onFocus={() => onFocusChange(true)}
      onBlur={() => onFocusChange(false)}
      onChange={handleChange}
    />
  );
};

const styles = cssInJS({
  default: {
    marginTop: 4,
    border: '1px solid #d9d9d9',
    padding: 4,
    width: '100%',
    borderRadius: 5,
    fontSize: THEME.editFontSize,
    fontFamily: THEME.fontFamily,
    marginBottom: 0,
    overflow: 'hidden',

    '@phone': {
      border: 'none',
      padding: 6,
    },
  },
});

export default NumberField;
